/* src/app/shared/components/tooltip/tooltip.component.scss */
.tooltip {
  z-index: 1001 !important;
  position: absolute;
  opacity: 1;
  border-radius: 12px;
  background-color: #61566e;
  box-shadow: 6px 6px 14px 0 rgba(0, 0, 0, 0.24);
  color: white;
  padding: 24px;
  animation: fadein 0.5s;
  max-width: 320px;
  min-width: 290px;
}
.tooltip h1 {
  font-size: 16px;
  line-height: 1.25;
  letter-spacing: 1.5px;
  font-family: "Lato-Bold";
  color: #ffffff;
  text-transform: uppercase;
}
.tooltip .body {
  font-size: 14px;
  margin-top: 16px;
  color: #ffffff;
}
.arrow,
.arrow-bottom,
.arrow-top,
.arrow-right,
.arrow-left {
  animation: fadein 0.5s;
  position: absolute;
  width: 0;
  height: 0;
  z-index: 1002 !important;
}
.arrow-left {
  height: 25px;
  width: 25px;
  transform: rotate(135deg);
  border-radius: 0 0 4px 0;
  background:
    linear-gradient(
      to bottom right,
      transparent 50%,
      transparent 50%,
      #61566e 50%,
      #61566e 100%);
}
.arrow-right {
  height: 25px;
  width: 25px;
  transform: rotate(-45deg);
  border-radius: 0 0 4px 0;
  background:
    linear-gradient(
      to bottom right,
      transparent 50%,
      transparent 50%,
      #61566e 50%,
      #61566e 100%);
}
.arrow-top {
  height: 25px;
  width: 25px;
  transform: rotate(225deg);
  border-radius: 0 0 4px 0;
  background:
    linear-gradient(
      to bottom right,
      transparent 50%,
      transparent 50%,
      #61566e 50%,
      #61566e 100%);
}
.arrow-bottom {
  height: 25px;
  width: 25px;
  transform: rotate(45deg);
  border-radius: 0 0 4px 0;
  background:
    linear-gradient(
      to bottom right,
      transparent 50%,
      transparent 50%,
      #61566e 50%,
      #61566e 100%);
}
/*# sourceMappingURL=tooltip.component.css.map */
